<template>
  <client-only>
    <!-- Need to wrap in client-only tag because Modal component needs to access document object -->
    <Modal
      :show="addressVerificationState.modal.show"
      @closed="addressVerificationState.modal.show = false"
    >
      <template #body>
        <div class="address-verification-modal-body">
          <div>
            <p class="address-verification-message" style="color: red;">
              We've run into a problem verifying the address you entered
            </p>
          </div>
          <ul
            class="radio-list shipping-options"
            style="list-style-type: none;"
          >
            <li>
              <div class="option no-icon">
                <input
                  id="verifyEnteredAddress"
                  v-model="addressVerificationState.modal.selectedOption"
                  type="radio"
                  name="verifyAddressSelection"
                  value="verifyEnteredAddress"
                />
                <label for="verifyEnteredAddress">
                  <strong>Entered Address: </strong>
                  {{ addressString(addressVerificationState.enteredAddress) }}
                  [<span
                    style="text-decoration: underline; font-weight: bold;"
                    @click="addressVerificationState.modal.show = false"
                    >Edit</span
                  >]
                </label>
              </div>
            </li>
            <li v-if="addressVerificationState.suggestedAddress">
              <div class="option no-icon">
                <input
                  id="verifySuggestedAddress"
                  v-model="addressVerificationState.modal.selectedOption"
                  type="radio"
                  name="verifyAddressSelection"
                  value="verifySuggestedAddress"
                />
                <label for="verifySuggestedAddress">
                  <strong>Suggested Address: </strong>
                  {{ addressString(addressVerificationState.suggestedAddress) }}
                </label>
              </div>
            </li>
          </ul>
        </div>
        <div class="columns small-12 medium-9 large-6 end">
          <button class="primary full-width continue" @click="confirmClicked">
            Use this address
            <template v-if="!addressVerificationState.suggestedAddress"
              >anyway</template
            >
          </button>
        </div>
      </template>
    </Modal>
  </client-only>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '~/../common/components/Modal.vue'
import { getCheckoutAddressString } from '~/../common/utils/checkout'
export default {
  name: 'CheckoutModalAddressVerification',
  components: { Modal },
  computed: {
    ...mapGetters(['addressVerificationState']),
  },
  methods: {
    addressString(address) {
      return getCheckoutAddressString(address)
    },
    confirmClicked() {
      this.$store.dispatch('addressVerificationConfirmClicked')
    },
  },
}
</script>

<style scoped></style>
